/* JETSNUS tasuta kingitus: lisab/eemaldab 0 € kingitoote taustal, ilma lehte uuesti laadimata.
   Kingitus = rida omadusega _jl_gift VÕI kingitoote variant (ka siis, kui keegi lisas selle käsitsi). */
(function () {
  var C = window.JL_GIFT;
  if (!C || !C.enabled || !C.variants || !C.variants.length) return;

  var origFetch = null;
  var busy = false, again = false, timer = null;
  var KEY = 'jl_gift_state';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var MUT = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var giftIds = C.variants.map(function (v) { return String(v.id); });

  function schedule() { clearTimeout(timer); timer = setTimeout(run, 250); }
  function state() { try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save(s) { try { sessionStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }
  function isGift(i) { return (i.properties && i.properties._jl_gift) || giftIds.indexOf(String(i.variant_id)) !== -1; }
  function json(url, body) {
    return origFetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    });
  }

  function install() {
    // Shopacado mähib window.fetch'i ise; meie mähime selle PÄRAST teda, et kingituse
    // lisamine käiks läbi Shopacado (allahindluse allkiri arvestab siis ka kingituse rida)
    // ja et me reageeriks alles siis, kui Shopacado on oma arvutuse lõpetanud.
    origFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch(input, init);
      if (MUT.test(url)) p.then(schedule, function () {});
      return p;
    };
    var xo = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      if (MUT.test(String(u))) this.addEventListener('load', schedule);
      return xo.apply(this, arguments);
    };
    schedule();
  }
  function shopacadoReady() {
    var s = window.shopacado;
    if (!s) return false;
    return !!(s.payload && s.payload.multicurrency);
  }
  function waitShopacado(started) {
    started = started || Date.now();
    var hasEmbed = !!document.querySelector('script[src*="shopacado"]') || !!window.shopacado;
    if (!hasEmbed || shopacadoReady() || Date.now() - started > 6000) { install(); return; }
    setTimeout(function () { waitShopacado(started); }, 100);
  }

  async function refresh() {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    var r = await origFetch(location.pathname + '?sections=cart-drawer,cart-icon-bubble');
    if (!r.ok) return;
    var s = await r.json();
    var parse = function (html, sel) { var d = new DOMParser().parseFromString(html, 'text/html').querySelector(sel); return d ? d.innerHTML : null; };
    var drawer = document.querySelector('cart-drawer');
    var inner = document.getElementById('CartDrawer');
    if (inner && s['cart-drawer']) {
      var h = parse(s['cart-drawer'], '#CartDrawer');
      if (h !== null) inner.innerHTML = h;
      var ov = document.getElementById('CartDrawer-Overlay');
      if (ov && drawer) ov.addEventListener('click', function () { drawer.close(); });
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && s['cart-icon-bubble']) {
      var b = parse(s['cart-icon-bubble'], '.shopify-section');
      if (b !== null) bubble.innerHTML = b;
    }
  }

  async function run() {
    if (busy) { again = true; return; }
    busy = true;
    try {
      var cart = await (await origFetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      var gifts = cart.items.filter(isGift);
      var base = cart.items.filter(function (i) { return !isGift(i); }).reduce(function (s, i) { return s + i.final_line_price; }, 0);
      var st = state();
      var changed = false;

      if (base >= C.threshold) {
        // klient eemaldas kingituse ise -> ära lisa seansi jooksul uuesti
        if (!gifts.length && st.had) st.declined = true;
        if (gifts.length > 1 || (gifts[0] && gifts[0].quantity !== 1)) {
          var upd = {};
          gifts.forEach(function (g, n) { upd[g.key] = n === 0 ? 1 : 0; });
          await json(root + 'cart/update.js', { updates: upd });
          changed = true;
        }
        if (!gifts.length && !st.declined) {
          for (var k = 0; k < C.variants.length; k++) {
            var v = C.variants[k];
            if (!v.available) continue;
            var res = await json(root + 'cart/add.js', { id: v.id, quantity: 1, properties: { _jl_gift: '1' } });
            if (res.ok) { changed = true; gifts = [1]; break; }
          }
        }
      } else {
        st.declined = false;
        if (gifts.length) {
          var rm = {};
          gifts.forEach(function (g) { rm[g.key] = 0; });
          await json(root + 'cart/update.js', { updates: rm });
          changed = true; gifts = [];
        }
      }
      st.had = gifts.length > 0;
      save(st);
      if (changed) await refresh();
    } catch (e) {
      console.warn('jl-free-gift', e);
    } finally {
      busy = false;
      if (again) { again = false; schedule(); }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { waitShopacado(); }); else waitShopacado();
})();
